import { Prerender } from '@didi/adv-libs-preload';

import { getCookie } from './cookie';

import { CHANNEL_TYPE_MAP, CHANNEL_TYPES, DEFAULT_CHANNEL_TYPE, getParamsChannel, GROUP_TYPE_PARAM } from '@/utils/group';
// 初始化预加载iframe
export const initializePreloadResource = (url: string, pageId?: string) => {
    const isJumpH5ocr = getParamsChannel(GROUP_TYPE_PARAM, CHANNEL_TYPES, DEFAULT_CHANNEL_TYPE) === CHANNEL_TYPE_MAP.h5ocr;

    if (isJumpH5ocr) {
        try {
            const preloader = new Prerender({
                url,
                pageId: pageId || window.__PAGE_CONFIG__?.pageId,
            });

            preloader.initPreloadResource();
        } catch (error) {
            console.error('initializePreloadIframe error', error);
        }
    }

};

/**
 * 初始化预加载 iframe
 * @param url - 要预加载的 URL
 * @param pageId - 页面 ID，默认为 window.__PAGE_CONFIG__?.pageId
 */
export const initializePreloadIframe = (url: string, checkApollo?: boolean) => {
    try {
        const preloader = new Prerender({
            url,
            pageId: window.__PAGE_CONFIG__?.pageId,
            checkApollo: checkApollo
        });

        preloader.initPreloadIframe();
        window.preloader = preloader;
    } catch (error) {
        console.error('initializePreloadIframe error', error);
    }
};

/**
 * 调用预加载器的登录成功方法
 * @param res - 登录成功返回的数据
 */
export const loginSuccessIframe = (res: any) => {
    const preloader = window.preloader;

    if (preloader && preloader.loginSuccess) {
        preloader.loginSuccess(res);
    }
};
